import {
    changeFieldProperty,
    setFieldVisibility,
    setDataList,
    setFieldEdition,
    setFieldListOptions,
    setFieldStartDate,
    changeFieldDisabled
} from "../../../../../apps/KpModule/actions"
import {generateFetchFieldListAction, GET_OBJECT_SUCCESS} from "../../../../../apps/KpModule/actions/api"
import moment from "moment"
import {ObjectId} from "bson"
import _ from "lodash"
import {getFormValues} from "redux-form"
import {calculateReversionMaxAmount} from "../utils"
import {liberalityReversionDepartureStatusObjects} from "../../staticEntities"

const recalculateReversionMaxAmount = (module, store) => {
    const departuresField = module.viewMap.form.fields.find(f => f.path === 'departures')
    const getField = path => departuresField.viewMap.form.fields.find(f => f.path === path)

    const reversionMaxAmountField = getField('reversionMaxAmount')
    const reversionAmountField = getField('reversionAmount')

    const beneficiary = getField('beneficiary').getValue()
    const asset = getField('asset').getValue()

    if (!beneficiary?.id || !asset?.id) {
        reversionMaxAmountField.setValue(0)
        //store.dispatch(changeFieldProperty(reversionAmountField.id, 'maxValue', 0))
        return
    }

    const state = store.getState()
    const currentDeparture = getFormValues('departuresEditObject')(state) || {}
    const liberalityRecord = getFormValues('editObject')(state) || {}

    const reversionMaxAmount = calculateReversionMaxAmount({
        id: currentDeparture.id,
        beneficiary,
        asset,
        liberalityRecord: liberalityRecord
    })

    reversionMaxAmountField.setValue(reversionMaxAmount)
    //store.dispatch(changeFieldProperty(reversionAmountField.id, 'maxValue', reversionMaxAmount))
}

const recalculateAdvanceRecoveryMaxAmount = (module, store, beneficiaryId) => {
    const departuresField = module.viewMap.form.fields.find(f => f.path === 'departures')
    const getField = path => departuresField.viewMap.form.fields.find(f => f.path === path)

    const advanceRecoveryMaxAmountField = getField('advanceRecoveryMaxAmount')

    if (!beneficiaryId) {
        advanceRecoveryMaxAmountField.setValue(0)
        return
    }

    store.dispatch(generateFetchFieldListAction(
        "m-C-liberalityReversion.LiberalityReversionDeparture_advance",
        store.getState,
        {data: {beneficiaryId}}
    )).then(action => {
        const advance = (action?.data || [])[0]
        if (!advance) return advanceRecoveryMaxAmountField.setValue(0)

        const state = store.getState()
        const currentDeparture = getFormValues('departuresEditObject')(state) || {}
        const liberalityRecord = getFormValues('editObject')(state) || {}

        // les reprises des autres dossiers sont prises en base, celles du dossier courant depuis le formulaire
        const currentAssetIds = (liberalityRecord.assetsInfos || []).map(asset => `${asset.id}`)
        const otherRecordsImputedTotal = _.sumBy(
            (advance.imputations || []).filter(imputation => !currentAssetIds.includes(`${imputation.asset?.id}`)),
            imputation => imputation.advanceRecoveryAmount || 0
        )
        const currentRecordImputedTotal = _.sumBy(
            (liberalityRecord.departures || []).filter(departure =>
                `${departure.id}` !== `${currentDeparture.id}` &&
                departure.departureForm?.id === 'advanceRecovery' &&
                `${departure.beneficiary?.id}` === `${beneficiaryId}`
            ),
            departure => departure.advanceRecoveryAmount || 0
        )

        const advanceRecoveryMaxAmount = advance.grantedTotal - otherRecordsImputedTotal - currentRecordImputedTotal
        advanceRecoveryMaxAmountField.setValue(advanceRecoveryMaxAmount)
    })
}

const recalculateMinOfAdvanceRecoveryMaxAmountAndReversionMaxAmount = (module, store) => {
    const departuresField = module.viewMap.form.fields.find(f => f.path === 'departures')
    const getField = path => departuresField.viewMap.form.fields.find(f => f.path === path)

    const advanceRecoveryMaxAmount = getField('advanceRecoveryMaxAmount').getValue() || 0
    const reversionMaxAmount = getField('reversionMaxAmount').getValue() || 0
    const minAmount = Math.min(advanceRecoveryMaxAmount, reversionMaxAmount)

    getField('minOfAdvanceRecoveryMaxAmountAndReversionMaxAmount').setValue(minAmount)
    store.dispatch(changeFieldProperty(getField('advanceRecoveryAmount').id, 'maxValue', minAmount))
}

export const module_ = {
    object: 'LiberalityRecord',
    name: 'LiberalityReversion',
    tKey: 'Reversion',
    category: {
        path: 'menuTitle_liberalities',
        icon: 'testament'
    },
    defaultSortBy: 'updatedAt',
    defaultSortDirection: 'DESC',
    newable: false,
    viewMap: {
        dt: [
            {path: 'presentationDate', tKey: 'Présentation', initiallyNotVisible: true},
            {path: 'fileApplicationNumberAndBenefactor', tKey: 'Dossier', initiallyNotVisible: true},
            {path: 'benefactor', tKey: 'Bienfaiteur(rice)'},
            {path: 'administrator', display: 'fullName', tKey: 'Gestionnaire', initiallyNotVisible: true},
            {path: 'typeOfFile', display: 'code', tKey: 'Nature', initiallyNotVisible: true},
            {path: 'qualificationsDisplay', tKey: 'Qualification(s)', initiallyNotVisible: true,},
            {path: 'beneficiaries', tKey: 'Bénéficiaire(s)'},
            {path: 'netForecastTotal', tKey: 'Net prévu (€)', tooltip: true},
            {path: 'netAchievedTotal', tKey: 'Net réalisé (€)', tooltip: true},
            {path: 'receivedTotal', tKey: 'Reçu (€)', tooltip: true},
            {path: 'reversedAndAdvanceRecoveryTotal', tKey: 'Reversé (€)', tooltip: true},
            {path: 'advanceRecoveryTotal', tKey: "Reprise d'avance (€)", tooltip: true, initiallyNotVisible: true},
            {path: 'reversedTotal', tKey: 'Versement (€)', tooltip: true, initiallyNotVisible: true},
            {path: 'CNDAShare', tKey: 'Dont part CNDA prévu (€)', tooltip: true, initiallyNotVisible: true},
            {path: 'CNDAShareTotal', tKey: 'Part CNDA reçu (€)', tooltip: true, initiallyNotVisible: true},
            {path: 'status', tKey: 'Statut', type: 'status', fieldPath: ['id', 'name', 'bStyle']},
            {path: 'decisionDate', tKey: 'Date décision', initiallyNotVisible: true},
            {path: 'updatedBy', tKey: 'MAJ par', initiallyNotVisible: true},
            {path: 'updatedAt', tKey: 'MAJ le', initiallyNotVisible: true},
            {path: 'noDeleteButtonAccess', hidden: true},
        ],
        form: {
            fields: [
                {
                    path: 'fileApplicationNumberAndBenefactor',
                    disabled: true,
                    widthClassName: 'col-xs-12 col-sm-6',
                    tKey: 'Dossier'
                },
                {path: 'administrator', display: 'fullName', tKey: 'Gestionnaire', filters: ['eligibleToLiberalityProcess'], widthClassName: 'col-xs-12 col-sm-6'},
                {path: 'typeOfFile', display: 'fullName', tKey: 'Nature', disabled: true, widthClassName: 'col-xs-12 col-sm-6'},
                {path: 'benefactor', tKey: 'Bienfaiteur(rice)', disabled: true, widthClassName: 'col-xs-12 col-sm-6'},
                {path: 'decisionDate', tKey: 'Date décision', disabled: true, widthClassName: 'col-xs-12 col-sm-6'},
                {path: 'beneficiaries', tKey: 'Bénéficiaire(s)', disabled: true},

                {
                    path: 'assetsInfos',
                    tKey: 'Suivi des biens',
                    newable: false,
                    removable: false,
                    defaultSortBy: 'achievedDate',
                    defaultSortDirection: 'DESC',
                    viewMap: {
                        dt: [
                            {path: 'typeOfProperty', tKey: 'Catégorie'},
                            {path: 'identifier', tKey: 'Bien'},
                            {path: 'estimatedAssetNetValue', tKey: 'Net prévu (€)', type: 'number', numberOfDecimals: 2, tooltip: true},
                            {path: 'netAmount', tKey: 'Net réalisé (€)', tooltip: true},
                            {path: 'achievedDate', tKey: 'Réalisé le'},
                        ],
                        form: [
                            {
                                path: 'distribution',
                                hidden: true,
                                viewMap: {
                                    dt: [{path: 'beneficiary', fieldPath: ['id', 'zipCodeAndName']}, 'share'],
                                    form: [{path: 'beneficiary', fieldPath: ['id', 'zipCodeAndName']}, 'share']
                                }
                            },
                            {path: 'typeOfProperty', tKey: 'Catégorie', disabled: true, widthClassName: 'col-xs-12 col-sm-6'},
                            {path: 'identifier', tKey: 'Bien', disabled: true, widthClassName: 'col-xs-12 col-sm-6'},
                            {path: 'estimatedAssetNetValue', tKey: 'Net prévu (€)', disabled: true, widthClassName: 'col-xs-12 col-sm-6'},
                            {
                                path: 'netAmount',
                                tKey: 'Net réalisé (€)',
                                required: true,
                                minValue: 0,
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {formInitialize, module, store}) => {
                                        if (!formInitialize) return
                                        const assetsField = module.viewMap.form.fields.find(f => f.path === 'assetsInfos')
                                        const netAmountField = assetsField.viewMap.form.fields.find(f => f.path === 'netAmount')
                                        const isAcceptedOrReopened = ['validated', 'reopened'].includes(_.get(store.getState(), 'edit.object.data.status.id'))
                                        store.dispatch(changeFieldProperty(netAmountField.id, 'editable', isAcceptedOrReopened && !newValue))
                                    }
                                }
                            },
                            {
                                path: 'achievedDate',
                                tKey: 'Réalisé le',
                                required: true,
                                endDate: moment().format('YYYY-MM-DD'),
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {formInitialize, module, store}) => {
                                        if (!formInitialize) return
                                        const assetsField = module.viewMap.form.fields.find(f => f.path === 'assetsInfos')
                                        const achievedDateField = assetsField.viewMap.form.fields.find(f => f.path === 'achievedDate')
                                        const isAcceptedOrReopened = ['validated', 'reopened'].includes(_.get(store.getState(), 'edit.object.data.status.id'))
                                        store.dispatch(changeFieldProperty(achievedDateField.id, 'editable', isAcceptedOrReopened && !newValue))
                                    }
                                }
                            }
                        ]
                    },
                    subscriptions: {
                        // Une entrée (fonds reçu) ne peut être saisie que sur un bien réalisé
                        onChange: (newValue, oldValue, {module, store}) => {
                            const entriesField = module.viewMap.form.fields.find(f => f.path === 'entries')
                            const entryAssetField = entriesField.viewMap.form.fields.find(f => f.path === 'asset')
                            const realizedAssetIds = (newValue || [])
                                .filter(asset => asset.netAmount != null && asset.achievedDate)
                                .map(asset => asset.id)
                            store.dispatch(setFieldListOptions(entryAssetField.id, realizedAssetIds))
                        }
                    }
                },

                {
                    path: 'entries',
                    tKey: 'Suivi des fonds reçus',
                    removable: false,
                    defaultSortBy: 'date',
                    defaultSortDirection: 'DESC',
                    viewMap: {
                        dt: [
                            {path: 'date', tKey: 'Date'},
                            {path: 'receivedAmount', tKey: 'Reçu (€)', tooltip: true},
                            {path: 'asset', tKey: 'Bien', display: 'identifier'},
                            {path: 'reason', tKey: 'Motif', display: 'name'},
                            {path: 'CNDAShare', tKey: 'Part CNDA (€)', tooltip: true},
                        ],
                        form: [
                            {
                                path: 'date',
                                tKey: 'Date',
                                required: true,
                                editable: false,
                                endDate: moment().format('YYYY-MM-DD'),
                                widthClassName: 'col-xs-12 col-sm-6',
                            },
                            {
                                path: 'receivedAmount',
                                tKey: 'Reçu (€)',
                                required: true,
                                editable: false,
                                minValue: 0,
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {module}) => {
                                        const entriesField = module.viewMap.form.fields.find(f => f.path === 'entries')
                                        const CNDAShareField = entriesField.viewMap.form.fields.find(f => f.path === 'CNDAShare')

                                        const decisionDateField = module.viewMap.form.fields.find(f => f.path === 'decisionDate')
                                        const decisionDate = decisionDateField.getValue()
                                        const rate = decisionDate && moment(decisionDate).isSameOrAfter('2021-09-01', 'day') ? 6 : 3

                                        CNDAShareField.setValue((newValue ?? 0) * rate / 100)
                                    }
                                }
                            },
                            {
                                path: 'asset',
                                tKey: 'Bien',
                                display: 'identifier',
                                required: true,
                                editable: false,
                                filters: ['byLiberalityRecord'],
                                widthClassName: 'col-xs-12 col-sm-6',
                            },
                            {
                                path: 'reason',
                                tKey: 'Motif',
                                display: 'name',
                                required: true,
                                editable: false,
                                sortList: false,
                                widthClassName: 'col-xs-12 col-sm-6',
                            },
                            {path: 'comment', tKey: 'Commentaire', type: 'richTextEditor'},
                            {path: 'CNDAShare', tKey: 'Part CNDA (€)', disabled: true, default: 0, widthClassName: 'col-xs-12 col-sm-6'},
                        ]
                    }
                },

                {
                    path: 'receivables',
                    tKey: 'Dettes',
                    defaultSortBy: 'pieceDate',
                    defaultSortDirection: 'DESC',
                    viewMap: {
                        dt: [
                            {path: 'pieceNumber', tKey: 'N° pièce'},
                            {path: 'pieceDate', tKey: 'Date pièce'},
                            {path: 'creditor', tKey: 'Créancier', display: 'name'},
                            {path: 'expenseCategory', tKey: 'Catégorie', display: 'name', initiallyNotVisible: true},
                            {path: 'totalAmount', tKey: 'Total (€)', tooltip: true},
                            {path: 'dueDate', tKey: "Date d'échéance", initiallyNotVisible: true},
                            {path: 'status', tKey: 'Statut', display: 'name'},
                            {path: 'settlementDate', tKey: 'Date règlement', initiallyNotVisible: true},
                        ],
                        form: [
                            {path: 'pieceNumber', tKey: 'N° pièce', required: true, editable: false, widthClassName: 'col-xs-12 col-sm-6'},
                            {
                                path: 'pieceDate',
                                tKey: 'Date pièce',
                                required: true,
                                editable: false,
                                endDate: moment().format('YYYY-MM-DD'),
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, { module, store }) => {
                                        const receivablesField = module.viewMap.form.fields.find(f => f.path === 'receivables')
                                        const dueDateField = receivablesField.viewMap.form.fields.find(f => f.path === 'dueDate')
                                        store.dispatch(setFieldStartDate(dueDateField.id, newValue || moment().format('YYYY-MM-DD')))
                                    }
                                }
                            },
                            {
                                path: 'creditor',
                                tKey: 'Créancier',
                                display: 'name',
                                required: true,
                                editable: false,
                                filters: ['isSupplier'],
                                widthClassName: 'col-xs-12 col-sm-6'
                            },
                            {
                                path: 'expenseCategory',
                                tKey: 'Catégorie',
                                display: 'name',
                                required: true,
                                editable: false,
                                filters: ['active'],
                                widthClassName: 'col-xs-12 col-sm-6'
                            },
                            {
                                path: 'totalAmount',
                                tKey: 'Total (€)',
                                required: true,
                                editable: false,
                                minValue: 0,
                                widthClassName: 'col-xs-12 col-sm-6'
                            },
                            {path: 'dueDate', tKey: "Date d'échéance", editable: false, startDate: moment().format('YYYY-MM-DD'), widthClassName: 'col-xs-12 col-sm-6'},
                            {
                                path: 'imputations',
                                tKey: 'Imputation(s)',
                                editable: false,
                                viewMap: {
                                    dt: [
                                        {path: 'asset', tKey: 'Bien', display: 'identifier'},
                                        {path: 'beneficiary', tKey: 'Bénéficiaire', display: 'zipCodeAndName'},
                                        {path: 'beneficiaryShare', tKey: 'Quote-part (%)', numberOfDecimals: 2},
                                        {path: 'imputedAmount', tKey: 'Imputé (€)', type: 'editNumber', editable: false},
                                    ]
                                },
                                validations: [
                                    function() {
                                        return function validation(value, values) {
                                            const totalAmount = values.totalAmount
                                            const imputedTotal = _.sumBy(value || [], o => Number(o.imputedAmount) || 0)
                                            return Math.abs((totalAmount || 0) - imputedTotal) > 0 ? 'imputedAmountsMustEqualTotalAmount' : undefined
                                        }
                                    }
                                ]
                            },
                            {
                                path: 'status',
                                tKey: 'Statut',
                                display: 'name',
                                required: true,
                                sortList: false,
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {module, store, formInitialize}) => {
                                        const receivablesField = module.viewMap.form.fields.find(f => f.path === 'receivables')
                                        const settlementDateField = receivablesField.viewMap.form.fields.find(f => f.path === 'settlementDate')

                                        if (!formInitialize) {
                                            settlementDateField.setValue(null)
                                        }

                                        const isSettled = newValue?.id === 'settled'
                                        store.dispatch(setFieldVisibility(settlementDateField.id, isSettled))
                                        store.dispatch(changeFieldProperty(settlementDateField.id, 'required', isSettled))
                                    }
                                }
                            },
                            {
                                path: 'settlementDate',
                                tKey: 'Date de règlement',
                                hidden: true,
                                endDate: moment().format('YYYY-MM-DD'),
                                widthClassName: 'col-xs-12 col-sm-6'
                            },
                            {path: 'comment', tKey: 'Commentaire', type: 'richTextEditor'},
                            {path: 'files', tKey: 'Pièces', type: 'simpleFiles'}
                        ]
                    }
                },

                {
                    path: 'departures',
                    tKey: 'Suivi des reversions',
                    removable: false,
                    //defaultSortBy: 'date',
                    //defaultSortDirection: 'DESC',
                    viewMap: {
                        dt: [
                            {path: 'date', tKey: 'Date'},
                            {path: 'beneficiary', tKey: 'Bénéficiaire', display: 'zipCodeAndName'},
                            {path: 'asset', tKey: 'Bien', display: 'identifier'},
                            {path: 'reversionAmount', tKey: 'Versement (€)', tooltip: true},
                            {path: 'advanceRecoveryAmount', tKey: "Reprise d'avance (€)", tooltip: true},
                            {path: 'status', tKey: 'Statut', display: 'name', initiallyNotVisible: true},
                            {path: 'executedDate', tKey: 'Exécuté le'},
                        ],
                        form: [
                            {
                                path: 'date',
                                tKey: 'Date',
                                required: true,
                                endDate: moment().format('YYYY-MM-DD'),
                                editable: false,
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {module, store}) => {
                                        const departuresField = module.viewMap.form.fields.find(f => f.path === 'departures')
                                        const executedDateField = departuresField.viewMap.form.fields.find(f => f.path === 'executedDate')
                                        store.dispatch(changeFieldProperty(executedDateField.id, 'startDate', newValue))
                                    }
                                }
                            },
                            {
                                path: 'beneficiary',
                                tKey: 'Bénéficiaire',
                                display: 'zipCodeAndName',
                                required: true,
                                editable: false,
                                filters: ['inLiberalityRecordDistribution'],
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {module, store}) => {
                                        const liberalityRecordId = getFormValues('editObject')(store.getState())?.id
                                        if (!liberalityRecordId) return

                                        store.dispatch(generateFetchFieldListAction(
                                            "m-C-liberalityReversion.LiberalityReversionDeparture_asset",
                                            store.getState,
                                            {data: {liberalityRecordId, beneficiaryId: newValue?.id}}
                                        ))

                                        recalculateReversionMaxAmount(module, store)
                                        recalculateAdvanceRecoveryMaxAmount(module, store, newValue?.id)
                                    }
                                }
                            },
                            {
                                path: 'asset',
                                tKey: 'Bien',
                                display: 'identifier',
                                required: true,
                                editable: false,
                                filters: ['byLiberalityRecordAndBeneficiary'],
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {module, store}) => {
                                        recalculateReversionMaxAmount(module, store)
                                    }
                                }
                            },
                            {
                                path: 'advance',
                                hidden: true,
                                filters: ['byBeneficiary'],
                                fieldPath: ['grantedTotal', 'imputations'],
                            },
                            {
                                path: 'departureForm',
                                tKey: 'Forme',
                                display: 'name',
                                required: true,
                                sortList: false,
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {module, store, formInitialize}) => {
                                        const departuresField = module.viewMap.form.fields.find(f => f.path === 'departures')
                                        const getField = path => departuresField.viewMap.form.fields.find(f => f.path === path)

                                        const isReversion = newValue?.id === 'reversion'
                                        const isAdvanceRecovery = newValue?.id === 'advanceRecovery'

                                        store.dispatch(setFieldVisibility(getField('reversionMaxAmount').id, isReversion))
                                        store.dispatch(setFieldVisibility(getField('reversionAmount').id, isReversion))
                                        store.dispatch(changeFieldProperty(getField('reversionAmount').id, 'required', isReversion))

                                        store.dispatch(setFieldVisibility(getField('minOfAdvanceRecoveryMaxAmountAndReversionMaxAmount').id, isAdvanceRecovery))
                                        store.dispatch(setFieldVisibility(getField('advanceRecoveryAmount').id, isAdvanceRecovery))
                                        store.dispatch(changeFieldProperty(getField('advanceRecoveryAmount').id, 'required', isAdvanceRecovery))

                                        const statusField = getField('status')
                                        store.dispatch(setFieldVisibility(statusField.id, isReversion))

                                        const executedDateField = getField('executedDate')

                                        if (isAdvanceRecovery) {
                                            statusField.setValue(liberalityReversionDepartureStatusObjects.find(status => status.id === 'allocated'))
                                            executedDateField.setValue(moment().format('YYYY-MM-DD'))
                                            store.dispatch(setFieldVisibility(executedDateField.id, false))
                                        } else if (isReversion) {
                                            store.dispatch(setDataList(
                                                "m-C-liberalityReversion.LiberalityReversionDeparture_status",
                                                liberalityReversionDepartureStatusObjects.filter(status => status.id !== 'allocated')
                                            ))
                                            if (statusField.getValue()?.id === 'allocated') statusField.setValue(null)
                                        }

                                        if (!formInitialize) {
                                            if (!isAdvanceRecovery) getField('advanceRecoveryAmount').setValue(null)
                                            if (!isReversion) getField('reversionAmount').setValue(null)
                                        }
                                    }
                                }
                            },
                            {
                                path: 'reversionMaxAmount',
                                tKey: 'Versement maximum (€)',
                                disabled: true,
                                hidden: true,
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {module, store}) => {
                                        recalculateMinOfAdvanceRecoveryMaxAmountAndReversionMaxAmount(module, store)
                                    }
                                }
                            },
                            {
                                path: 'reversionAmount',
                                tKey: 'Versement (€)',
                                minValue: 0,
                                editable: false,
                                hidden: true,
                                widthClassName: 'col-xs-12 col-sm-6',
                            },
                            {
                                path: 'advanceRecoveryMaxAmount',
                                tKey: "Reprise d'avance maximum (€)",
                                disabled: true,
                                hidden: true,
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {module, store}) => {
                                        recalculateMinOfAdvanceRecoveryMaxAmountAndReversionMaxAmount(module, store)
                                    }
                                }
                            },
                            {
                                path: 'minOfAdvanceRecoveryMaxAmountAndReversionMaxAmount',
                                tKey: "Reprise d'avance maximum (€)",
                                disabled: true,
                                hidden: true,
                                widthClassName: 'col-xs-12 col-sm-6',
                            },
                            {
                                path: 'advanceRecoveryAmount',
                                tKey: "Reprise d'avance (€)",
                                editable: false,
                                minValue: 0,
                                hidden: true,
                                widthClassName: 'col-xs-12 col-sm-6',
                            },
                            {path: 'comment', tKey: 'Commentaire', type: 'richTextEditor'},
                            {
                                path: 'status',
                                tKey: 'Statut',
                                display: 'name',
                                required: true,
                                sortList: false,
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {module, store, formInitialize}) => {
                                        const departuresField = module.viewMap.form.fields.find(f => f.path === 'departures')
                                        const executedDateField = departuresField.viewMap.form.fields.find(f => f.path === 'executedDate')
                                        const reversionAmountField = departuresField.viewMap.form.fields.find(f => f.path === 'reversionAmount')
                                        const advanceRecoveryAmountField = departuresField.viewMap.form.fields.find(f => f.path === 'advanceRecoveryAmount')

                                        if (!formInitialize) {
                                            executedDateField.setValue(null)
                                        }

                                        const isExecuted = newValue?.id === 'paid'
                                        const isAllocated = newValue?.id === 'allocated'
                                        store.dispatch(setFieldVisibility(executedDateField.id, isExecuted))
                                        store.dispatch(changeFieldProperty(executedDateField.id, 'required', isExecuted))
                                        store.dispatch(changeFieldProperty(reversionAmountField.id, 'editable', !isExecuted))
                                        store.dispatch(changeFieldProperty(advanceRecoveryAmountField.id, 'editable', !isAllocated))
                                    }
                                }
                            },
                            {
                                path: 'executedDate',
                                tKey: 'Exécuté le',
                                hidden: true,
                                endDate: moment().format('YYYY-MM-DD'),
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {formInitialize, module, store}) => {
                                        if (!formInitialize) return
                                        const departuresField = module.viewMap.form.fields.find(f => f.path === 'departures')
                                        const executedDateField = departuresField.viewMap.form.fields.find(f => f.path === 'executedDate')
                                        store.dispatch(changeFieldProperty(executedDateField.id, 'editable', !newValue))
                                    }
                                }
                            },
                            {path: 'includedEntries', hidden: true},
                            {path: 'includedReceivables', hidden: true},
                            {path: 'includedSolicitations', hidden: true},
                            {path: 'order', hidden: true}
                        ]
                    }
                },

                {path: 'conversations', tKey: "zone d'échanges"},
                {path: 'buttons', hidden: true}
            ],
            onOpen: ({store, module}) => {
                const statusId = _.get(store.getState(), 'edit.object.data.status.id')
                // Gestionnaire, Historique d'échanges : modifiables sauf Abandon, Renonciation, Clos
                const notLockedFields = module.viewMap.form.fields.filter(field => ['administrator', 'conversations'].includes(field.path))
                notLockedFields.forEach(field => store.dispatch(setFieldEdition(field.id, !['abandoned', 'rejected', 'closed'].includes(statusId))))

                // Suivi des biens, des entrées (fonds reçus), Dettes, Suivi des sorties (reversions) : modifiables en Acceptation ou Rouvert
                const followUpFields = module.viewMap.form.fields.filter(field => ['assetsInfos', 'entries', 'receivables', 'departures'].includes(field.path))
                followUpFields.forEach(field => store.dispatch(changeFieldDisabled(field.id, !['validated', 'reopened'].includes(statusId))))
            }
        }
    },
    filters: ['byReversionStatus'],
    actionSubscriptions: [
        {
            actionType: GET_OBJECT_SUCCESS,
            subscription: ({ store, module }) => {
                const state = store.getState()
                const liberalityRecord = _.pick(state.edit.object.data, ['id'])
                const assetsInfos = _.get(state, 'edit.object.data.assetsInfos')

                const imputationTemplate = (assetsInfos || []).flatMap(assetInfo =>
                    (assetInfo.distribution || []).map(dist => ({
                        id: new ObjectId(),
                        asset: {id: assetInfo.id, identifier: assetInfo.identifier},
                        beneficiary: dist.beneficiary,
                        beneficiaryShare: dist.share,
                        imputedAmount: 0
                    }))
                )

                const receivablesField = module.viewMap.form.fields.find(f => f.path === 'receivables')
                const imputationsField = receivablesField.viewMap.form.fields.find(f => f.path === 'imputations')
                store.dispatch(changeFieldProperty(imputationsField.id, 'default', imputationTemplate))

                store.dispatch(generateFetchFieldListAction(
                    "m-C-liberalityReversion.LiberalityReversionEntry_asset",
                    store.getState,
                    {data: {liberalityRecordId: liberalityRecord?.id}}
                )).then(() => {
                    // Le chargement des options écrase la restriction : on la réapplique (entrées uniquement sur les biens réalisés)
                    const entriesField = module.viewMap.form.fields.find(f => f.path === 'entries')
                    const entryAssetField = entriesField.viewMap.form.fields.find(f => f.path === 'asset')
                    const realizedAssetIds = (assetsInfos || [])
                        .filter(asset => asset.netAmount != null && asset.achievedDate)
                        .map(asset => asset.id)
                    store.dispatch(setFieldListOptions(entryAssetField.id, realizedAssetIds))
                })
                store.dispatch(generateFetchFieldListAction(
                    "m-C-liberalityReversion.LiberalityReversionDeparture_asset",
                    store.getState,
                    {data: {liberalityRecordId: liberalityRecord?.id}}
                ))
                store.dispatch(generateFetchFieldListAction(
                    "m-C-liberalityReversion.LiberalityReversionDeparture_beneficiary",
                    store.getState,
                    {data: {liberalityRecordId: liberalityRecord?.id}}
                ))
            }
        }
    ]
}